// extracted by mini-css-extract-plugin
export default {"list":"AuthList_list__x6Tv9","isModal":"AuthList_isModal__nam8K","link":"AuthList_link__dV-e7","action":"AuthList_action__DbjN+"};